export default __webpack_public_path__ + "static/media/Claxton-Bold.6ba86be5.otf";